import type { AttackCard, ImView, PublicTeamView, Stage } from "../types";

const STAGE_LABELS: Record<Stage, string> = {
  initialCompromise: "Initial Compromise",
  pivotEscalate: "Pivot / Escalate",
  c2Exfil: "C2 / Exfil",
  persistence: "Persistence",
};

interface Props {
  myTeam?: PublicTeamView;
  imView?: ImView;
}

export function AttackChain({ myTeam, imView }: Props) {
  const stages: Stage[] = ["initialCompromise", "pivotEscalate", "c2Exfil", "persistence"];
  return (
    <div className="chain">
      {stages.map((s) => {
        const found = myTeam?.found.find((f) => f.stage === s);
        const imCard = imView?.attackChain.find((c: AttackCard) => c.stage === s);
        const revealed = Boolean(found || imCard);
        return (
          <div key={s} className={`stage ${revealed ? "revealed" : ""}`}>
            <div className="label">{STAGE_LABELS[s]}</div>
            {found ? (
              <div className="name">Identified — {found.cardId.split(".").pop()}</div>
            ) : imCard ? (
              <div className="name">{imCard.name}</div>
            ) : (
              <div className="name" style={{ color: "var(--color-text-muted)" }}>?</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
